import { render, staticRenderFns } from "./ParentConsentConfirmed.vue?vue&type=template&id=3a953e8f&scoped=true&"
import script from "./ParentConsentConfirmed.vue?vue&type=script&lang=js&"
export * from "./ParentConsentConfirmed.vue?vue&type=script&lang=js&"
import style0 from "./ParentConsentConfirmed.vue?vue&type=style&index=0&id=3a953e8f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a953e8f",
  null
  
)

export default component.exports